import MundHotzapp from "../icons/MundHotzapp";
import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import HotzappIcon from '../icons/Hotzap';
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";

export default function Hotzapp() {
  return (
    <IntegrationTable
      integrationKey="hotzapp"
      title="Hotzapp"
      main_icon={<MundHotzapp />}
      icon={<HotzappIcon />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
    />
  );
}
